module.exports = "<div class=\"accordion-type-1\">\r\n  <ng-transclude></ng-transclude>\r\n  <span class=\"btn_icon icon--down_arrow\"></span>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/common/components/accordion/accordion-header-template.html
 ** module id = 838
 ** module chunks = 2
 **/